import {
  PublicBaseEventSerializer,
  TicketTypeSerializer,
} from "@shared/modules/events/types/public";
import { isSoldOutEvent } from "@shared/modules/events/utils/event-utils";

export const isTicketOnSale = (
  ticket: TicketTypeSerializer,
  now: Date,
  allowStartsOnBypass = false
) => {
  const saleStartDate = ticket.sale_starts_on
    ? new Date(ticket.sale_starts_on)
    : null;
  const saleEndDate = ticket.sale_ends_on
    ? new Date(ticket.sale_ends_on)
    : null;

  if (allowStartsOnBypass && saleStartDate && saleStartDate > now) {
    return true;
  }

  return (
    saleStartDate && saleEndDate && saleStartDate < now && saleEndDate > now
  );
};

export const isEventEligibleForUpsell = (
  event: PublicBaseEventSerializer
): boolean => {
  const now = new Date();

  if (!event.ticket_types?.length) {
    return false;
  }
  const {
    hasAvailableTickets,
    someTicketsPasswordProtected,
    hasFreeTickets,
    hasVoucherExclusive,
    hasCustomPackageTickets,
  } = event.ticket_types.reduce(
    (acc, ticket: TicketTypeSerializer) => {
      if (isTicketOnSale(ticket, now)) {
        acc.hasAvailableTickets = true;
      }
      if (ticket.is_password_protected) {
        acc.someTicketsPasswordProtected = true;
      }
      if (Number(ticket.price) !== 0) {
        acc.hasFreeTickets = false;
      }
      if (!ticket.voucher_purchases_only) {
        acc.hasVoucherExclusive = false;
      }
      if (!(ticket.is_custom_package || ticket.is_bundle)) {
        acc.hasCustomPackageTickets = false;
      }
      return acc;
    },
    {
      hasAvailableTickets: false,
      someTicketsPasswordProtected: false,
      hasFreeTickets: true,
      hasVoucherExclusive: true,
      hasCustomPackageTickets: true,
    }
  );

  return (
    !isSoldOutEvent(event) &&
    !event.is_password_protected &&
    (event.is_recurring === false || event.is_recurring === null) &&
    !someTicketsPasswordProtected &&
    !hasFreeTickets &&
    !hasCustomPackageTickets &&
    !hasVoucherExclusive &&
    hasAvailableTickets
  );
};
